import type { User } from '@supabase/supabase-js'

/**
 * Best-effort full name from the Supabase user's OAuth identity metadata.
 * Providers (LinkedIn, Google, Microsoft) populate `user_metadata` with some of
 * `full_name` / `name` / `given_name` + `family_name`. OTP-only signups have
 * none of these → returns null. Capped at 150 chars (the learner_profile limit).
 */
export function fullNameFromUser(user: User | null | undefined): string | null {
  const meta = (user?.user_metadata ?? {}) as Record<string, unknown>
  const direct = (meta.full_name || meta.name) as string | undefined
  const candidate =
    (direct && direct.trim()) ||
    [meta.given_name, meta.family_name].filter(Boolean).join(' ').trim()
  if (!candidate) return null
  return candidate.slice(0, 150)
}

/** Friendly first name (metadata → email local-part). */
export function firstNameFromUser(
  user: { email?: string; user_metadata?: Record<string, unknown> } | null | undefined,
): string {
  const full = fullNameFromUser(user as User)
  if (full) return full.split(' ')[0]
  if (user?.email) return user.email.split('@')[0]
  return ''
}
